<template>
    <v-dialog v-model="mostrar" persistent max-width="500">
        <v-card>
            <v-card-title class="headline">Compartir con usuarios</v-card-title>
            <v-card-text>
                <v-autocomplete
                    v-model="usuarioSel"
                    :items="usuarios"
                    label="Usuarios:"
                    item-value="_id"
                    item-text="nombreCompleto"
                    :filter="customFilter"
                >

                    <!-- SLOT PARA ELEMENTOS SELECCIONADOS -->
                    <template v-slot:selection="{ item }">
                        <!-- <v-chip close @click:close="usuarioSel.splice(index,1)"> -->
                            <span>{{item.titulo}} {{item.nombreCompleto}}</span>
                        <!-- </v-chip> -->
                    </template>
                    <template v-slot:item="{ item }">
                        <!-- <v-chip close @click:close="usuarioSel.splice(index,1)"> -->
                            {{item.titulo}} {{item.nombreCompleto}}
                        <!-- </v-chip> -->
                    </template>

                </v-autocomplete>
            </v-card-text>
            <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue-grey darken-1" small outlined text @click="$emit('cancelar')">Cancelar</v-btn>
            <v-btn color="blue-grey darken-1" small dark  @click="asignarCompartido()">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios'
import { mapGetters } from "vuex";

export default {
    props: ['oficio', 'mostrar', 'tipo'],
    components:{  },
    computed:{
        ...mapGetters([
            "httpURL", 
            "sessionToken",
            "userId",
            "role"
        ])
    },
    data: () => ({
        loading: false,
        usuarios: [],
        usuarioSel: null,
     
    }),
    created(){
        this.loading = true;
        axios.get(this.httpURL+'/oficios/'+this.tipo+'/compartido/'+this.oficio,
            {headers:{token:this.sessionToken}})
            .then(res => {
                if( res.data.ok ){
                    this.usuarios = res.data.usuarios;
                }else{
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                }
                this.loading = false;
            })
            .catch(error => {
                // console.log('Error: '+error);
                this.loading = false;
                this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
            });
    },
    methods:{
        
        asignarCompartido(){
            this.loading = true;
            axios.post(this.httpURL+'/oficios/'+this.tipo+'/compartido/'+this.oficio,
                { usuario: this.usuarioSel},
                { headers:{token:this.sessionToken}})
                .then(res => {
                    if( res.data.ok ){
                        this.$emit('compartidoModificado',{compartido:res.data.compartido, log:res.data.log});
                        // this.asignarDialog = false;
                    }else{
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    }
                    this.loading = false;
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
        },
        normalizarTexto(texto) {
            if (!texto) return ""; // Manejar valores nulos o vacíos
            return texto
                .normalize("NFD") // Divide caracteres acentuados
                .replace(/[\u0300-\u036f]/g, "") // Elimina marcas diacríticas
                .toLowerCase(); // Convierte a minúsculas
        },
        // Filtro personalizado para manejar búsqueda insensible a acentos
        customFilter(item, queryText, itemText) {
            // Normaliza el texto ingresado y el texto del ítem
            const textoBusquedaNormalizado = this.normalizarTexto(queryText);
            const textoItemNormalizado = this.normalizarTexto(itemText);

            // Realiza la comparación
            return textoItemNormalizado.includes(textoBusquedaNormalizado);
        },

    }
}

</script>